import Vue from 'vue'
import VueRouter from 'vue-router'

import AmwayRU   from '../views/AmwayRU.vue';
// import AmwayUA   from '../views/AmwayUA.vue';
import AmwayKZ   from '../views/AmwayKZ.vue';
import AppPage   from '../views/AppPage.vue';
import StartPage from '../views/StartPage.vue';
import History from "../views/History.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'AmwayRU',
    component: AmwayRU
  },
  {
    path: '/kz',
    name: 'AmwayKZ',
    component: AmwayKZ
  },
  // {
  //   path: '/ua',
  //   name: 'AmwayUA',
  //   component: AmwayUA
  // },
  {
    path: '/app',
    name: 'AppPage',
    component: AppPage
  },
  {
    path: '/start',
    name: 'StartPage',
    component: StartPage
  },
  {
    path: '/history',
    name: 'History',
    component: History
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
